function formatText(text) {
    return text
        .replace(/\\/g, '\\\\')   // екрануємо зворотні слеші
        .replace(/"/g, '\\"')     // екрануємо подвійні лапки
        .replace(/\n/g, ' ')    // замінюємо новий рядок на \n
        .replace(/\t/g, ' ');   // замінюємо табуляцію на \t
}

// ---------- helper: id-генератор (використовується для notes без id) ----------
function randomId(len = 8) {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
  let out = '';
  for (let i = 0; i < len; i++) out += alphabet[Math.floor(Math.random() * alphabet.length)];
  return out;
}


// ===================== shlex-подібний splitter =====================
function smartSplit(input) {
  const out = [];
  let buf = '';
  let quote = null;

  const push = () => { if (buf.length) out.push(buf); buf = ''; };

  for (let i = 0; i < input.length; i++) {
    const ch = input[i];

    if (quote) {
      if (ch === '\\') {
        if (i + 1 < input.length) { buf += input[i + 1]; i++; }
        else { buf += ch; }
      } else if (ch === quote) {
        quote = null;
      } else {
        buf += ch;
      }
      continue;
    }

    if (ch === '"' || ch === "'") { quote = ch; continue; }

    if (ch === ' ' || ch === '\t' || ch === '\r' || ch === '\n' || ch === ',') {
      if (buf.length) push();
      continue;
    }

    if (ch === '=') {
      if (buf.length) push();
      out.push('=');
      continue;
    }

    buf += ch;
  }
  push();

  // змерджити навколо '=' → ["a","=","b"] => ["a=b"], ["a=","b"] => ["a=b"]
  const tokens = [];
  for (let i = 0; i < out.length; i++) {
    const t = out[i];
    if (t === '=') {
      if (tokens.length && i + 1 < out.length) {
        const prev = tokens.pop();
        const next = out[i + 1];
        tokens.push(prev + '=' + next);
        i++;
        continue;
      }
      continue;
    }
    if (t.endsWith('=') && i + 1 < out.length && out[i + 1] !== '=') {
      tokens.push(t + out[i + 1]);
      i++;
      continue;
    }
    tokens.push(t);
  }
  return tokens;
}

// ===================== helpers =====================
function unquote(val) {
  if (!val || val.length < 2) return val;
  const q = val[0];
  if ((q === '"' || q === "'") && val[val.length - 1] === q) {
    return val.slice(1, -1).replace(/\\"/g, '"').replace(/\\'/g, "'");
  }
  return val;
}
function quote(val) {
  return `"${String(val).replace(/"/g, '\\"')}"`;
}

// ===================== Columns =====================
function parseColumn(line) {
  const tokens = smartSplit(line.trim());
  if (tokens.length < 2) throw new Error('Invalid column line: need <name> <type>');

  const col = { name: tokens[0], type: tokens[1], flags: {}, attributes: {} };

  for (let i = 2; i < tokens.length; i++) {
    const tok = tokens[i];
    const eq = tok.indexOf('=');
    if (eq === -1) {
      // col.flags.push(tok);
      col.flags[tok] = true;
    } else {
      const key = tok.slice(0, eq);
      const val = unquote(tok.slice(eq + 1));
      col.attributes[key] = val;
    }
  }
  return col;
}

function serializeColumn(col) {
  const parts = [col.name, col.type];
  for (const [k, v] of Object.entries(col.flags || {})) {
    parts.push(`${k}`);
  }
  for (const [k, v] of Object.entries(col.attributes || {})) {
    parts.push(`${k}=${quote(formatText(v))}`);
  }
  return parts.join(' ');
}

// ===================== Tables =====================
function parseTableHeader(line) {
  const tokens = smartSplit(line.trim());
  if (tokens.length < 1) throw new Error('Invalid table header');
  const name = tokens[0];
  const attrs = {};
  for (let i = 1; i < tokens.length; i++) {
    const tok = tokens[i];
    const eq = tok.indexOf('=');
    if (eq === -1) {
      attrs[tok] = ''; // флаг без значення (рідко, але збережемо)
    } else {
      const key = tok.slice(0, eq);
      const val = unquote(tok.slice(eq + 1));
      attrs[key] = val;
    }
  }
  return { name, attributes: attrs };
}

function serializeTableHeader(tbl) {
  const parts = [tbl.name];
  for (const [k, v] of Object.entries(tbl.attributes || {})) {
    parts.push(`${k}=${quote(formatText(v))}`);
  }
  return parts.join(' ');
}

// ===================== Relations (lines) =====================
function parseEndpoint(spec) {
  const mPar = /^([^(\s]+)\(([^)]+)\)$/;      // table(col1,col2)
  const mDot = /^([^.(\s]+)\.([^\s]+)$/;      // table.col
  let table = '', columns = [];

  if (mPar.test(spec)) {
    const [, t, inner] = spec.match(mPar);
    table = t;
    columns = inner.split(',').map(s => s.trim()).filter(Boolean);
  } else if (mDot.test(spec)) {
    const [, t, c] = spec.match(mDot);
    table = t;
    columns = [c.trim()];
  } else {
    table = spec.trim();
    columns = [];
  }
  return { table, columns };
}
function formatEndpoint(from) { // (from/to)
  if (!from) return '';
  if (Array.isArray(from.columns) && from.columns.length > 1) {
    return `${from.table}(${from.columns.join(',')})`;
  }
  if (Array.isArray(from.columns) && from.columns.length === 1) {
    return `${from.table}.${from.columns[0]}`;
  }
  return from.table;
}
function parseRefLine(line) {
  const trimmed = line.trim();
  if (!/^l:/i.test(trimmed)) throw new Error('Relation line must start with "l:"');
  const rest = trimmed.replace(/^l:\s*/i, '');
  const tokens = smartSplit(rest);
  if (tokens.length < 3) throw new Error('Invalid relation: expected "<from> <arrow> <to>"');

  const from = parseEndpoint(tokens[0]);
  const arrow = tokens[1]; // '>', '<', '-', '<->', '->', '<-', '<>'
  const to = parseEndpoint(tokens[2]);

  const attributes = {};
  for (let i = 3; i < tokens.length; i++) {
    const tok = tokens[i];
    const eq = tok.indexOf('=');
    if (eq === -1) { attributes[tok] = ''; continue; }
    const key = tok.slice(0, eq);
    const val = unquote(tok.slice(eq + 1));
    attributes[key] = val;
  }

  return { type: 'line', from, arrow, to, attributes };
}

function serializeRefLine(line) {
  const parts = ['l:', formatEndpoint(line.from), line.arrow || '>', formatEndpoint(line.to)];
  for (const [key, value] of Object.entries(line.attributes || {})) {
    parts.push(`${key}=${quote(formatText(value))}`);
  }
  return parts.join(' ');
}
// ===== notes (n:) =====
function parseNoteLine(line) {
  const t = line.trim();
  if (!/^n:/i.test(t)) throw new Error('Note line must start with "n:"');
  const rest = t.replace(/^n:\s*/i, '');

  const tokens = smartSplit(rest);
  if (!tokens.length) return { type: 'note', id: randomId(), text: '', attributes: {} };

  let idx = 0;
  let text = '';
  const attributes = {};

  // 1) якщо перший токен не має '=', трактуємо його як текст нотатки
  if (!tokens[0].includes('=')) {
    text = unquote(tokens[0]);
    idx = 1;
  }

  // 2) решта — атрибути (підтримка key="v", "key=v", xy=10 20/wh=10 20)
  for (; idx < tokens.length; idx++) {
    const tok = tokens[idx];
    const eq = tok.indexOf('=');

    if (eq !== -1) {
      const key = tok.slice(0, eq);
      let val = tok.slice(eq + 1);

      if (!/^["']/.test(val) && (key === 'xy' || key === 'wh') && idx + 1 < tokens.length) {
        const next = tokens[idx + 1];
        if (!next.includes('=')) { val = `${val} ${next}`; idx++; }
      }

      attributes[key] = unquote(val);
      continue;
    }

    const kvInOne = tok.indexOf('=');
    if (kvInOne > 0) {
      const key = tok.slice(0, kvInOne);
      const val = tok.slice(kvInOne + 1);
      attributes[key] = val;
    } else {
      attributes[tok] = '';
    }
  }

  // 3) гарантуємо наявність id
  const id = attributes.id ?? randomId();
  attributes.id = id;

  return { type: 'note', id, text, attributes };
}

// серіалізація: id завжди перший
function serializeNote(n) {
  const parts = ['n:'];
  if (n.text && n.text.length) parts.push(quote(formatText(n.text)));

  const attrs = { ...(n.attributes || {}) };
  const id = n.id || attrs.id || randomId();
  attrs.id = id;

  // Виводимо id першим
  parts.push(`id=${quote(attrs.id)}`);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === 'id') continue;
    parts.push(`${k}=${quote(formatText(v))}`);
  }
  return parts.join(' ');
}


// ===== pen (p:) =====
function parsePenLine(line) {
  const t = line.trim();
  if (!/^p:/i.test(t)) throw new Error('Pen line must start with "p:"');
  const rest = t.replace(/^p:\s*/i, '');
  const tokens = smartSplit(rest);

  const attributes = {};
  for (let i = 0; i < tokens.length; i++) {
    const tok = tokens[i];
    const eq = tok.indexOf('=');

    if (eq !== -1) {
      const key = tok.slice(0, eq);
      let val = tok.slice(eq + 1);

      // змерджити координати без лапок (xy/txy/oxy) типу: xy=100 200
      if (!/^["']/.test(val) && (key === 'xy' || key === 'txy' || key === 'oxy') && i + 1 < tokens.length) {
        const next = tokens[i + 1];
        if (!next.includes('=')) { val = `${val} ${next}`; i++; }
      }

      attributes[key] = unquote(val);
    } else {
      // флаг без значення (рідко)
      attributes[tok] = '';
    }
  }

  return { type: 'pen', attributes };
}

function serializePen(p) {
  const parts = ['p:'];
  for (const [k, v] of Object.entries(p.attributes || {})) {
    parts.push(`${k}=${quote(formatText(v))}`); // завжди лапкуємо, зручно для path з пробілами/комами
  }
  return parts.join(' ');
}

// ===== areas (a:) =====
function parseAreaHeader(line) {
  const t = line.trim();
  if (!/^a:/i.test(t)) throw new Error('Area line must start with "a:"');
  const rest = t.replace(/^a:\s*/i, '');
  const tokens = smartSplit(rest);

  const attributes = {};
  for (let i = 0; i < tokens.length; i++) {
    const tok = tokens[i];
    const eq = tok.indexOf('=');

    if (eq !== -1) {
      const key = tok.slice(0, eq);
      let val = tok.slice(eq + 1);

      if (!/^["']/.test(val) && (key === 'xy' || key === 'wh') && i + 1 < tokens.length) {
        const next = tokens[i + 1];
        if (!next.includes('=')) { val = `${val} ${next}`; i++; }
      }

      attributes[key] = unquote(val);
      continue;
    }

    const kvInOne = tok.indexOf('=');
    if (kvInOne > 0) {
      const key = tok.slice(0, kvInOne);
      const val = tok.slice(kvInOne + 1);
      attributes[key] = val;
    } else {
      attributes[tok] = '';
    }
  }
  return attributes;
}

/**
 * Читає area-блок: заголовок 'a:' + наступні непорожні рядки як elements.
 * Зупиняється на першому порожньому рядку (або на кінці документа).
 * @returns {{ area: { type:'area', attributes:Object, elements:string[] }, nextIndex:number }}
 */
function parseAreaBlock(lines, startIndex) {
  const headerLine = lines[startIndex];
  const attributes = parseAreaHeader(headerLine);

  const elements = [];
  let i = startIndex + 1;

  while (i < lines.length) {
    const raw = lines[i];
    if (!raw.trim()) break;             // кінець блоку areas — порожній рядок
    // рядок-учасник — беремо як є trimmed (одне слово)
    elements.push(raw.trim());
    i++;
  }

  return {
    area: { type: 'area', attributes, elements },
    nextIndex: i
  };
}

function serializeArea(a) {
  const headerParts = ['a:'];
  for (const [k, v] of Object.entries(a.attributes || {})) {
    headerParts.push(`${k}=${quote(formatText(v))}`);
  }
  const header = headerParts.join(' ');
  const elements = (a.elements || []).join('\n');
  return elements ? `${header}\n${elements}` : header;
}

// ===== globals (directives) lines: "-- key=..." =====
function isDirectiveLine(line) {
  return /^\s*--\s*/.test(line);
}

// Витягнути key і "решту після =" як сирий хвіст
function splitDirectiveKeyAndRhs(line) {
  const body = line.replace(/^\s*--\s*/, '');
  const eq = body.indexOf('=');
  if (eq === -1) return { key: body.trim(), rhs: '' };
  const key = body.slice(0, eq).trim();
  const rhs = body.slice(eq + 1).trim();
  return { key, rhs };
}

// Початок фенса? Підтримує ``` (рекомендовано) і `` (опційно)
function fenceInfo(rhs) {
  if (/^```/.test(rhs)) return { open: '```', inline: false };
  if (/^``(?!`)/.test(rhs)) return { open: '``', inline: false }; // опція з двома бектиками
  if (/^`(?!`)/.test(rhs)) return { open: '`', inline: true };   // однорядкові бектики
  return null;
}

/**
 * Парсить одну директиву. Якщо rhs починається з фенса ``` або `` — читає
 * наступні рядки до закриваючого фенса. Якщо rhs — одинарні бектики `...`,
 * це однорядковий варіант (без екранування лапок).
 *
 * @returns {{ directive:{key:string,value:string}, nextIndex:number }}
 */
function parseDirectiveAt(lines, startIndex) {
  const line = lines[startIndex];
  const { key, rhs } = splitDirectiveKeyAndRhs(line);

  const fi = fenceInfo(rhs);

  // Однорядковий у звичайних лапках/без них
  if (!fi) {
    // Підтримка звичайного однорядкового синтаксису: "..." або сирий текст
    // Використаємо існуючу unquote()
    const value = unquote(rhs);
    return { directive: { key, value }, nextIndex: startIndex + 1 };
  }

  // Однорядковий у одинарних бектиках: -- key=` ... `
  if (fi.inline) {
    // зняти крайні `
    const m = /^`([\s\S]*?)`$/.exec(rhs);
    const value = m ? m[1] : rhs.replace(/^`/, '').replace(/`$/, '');
    return { directive: { key, value }, nextIndex: startIndex + 1 };
  }

  // Багаторядковий: -- key=```  ... до рядка, що містить лише ```
  const fence = fi.open; // '```' або '``'
  let i = startIndex;
  // якщо після фенса на цьому ж рядку є текст (наприклад: -- key=```first line),
  // то беремо його як перший рядок значення
  let first = rhs.slice(fence.length);
  const chunks = [];
  if (first.length) chunks.push(first);

  // збираємо до закриття фенса в окремому рядку (можна з пробілами довкола)
  for (i = startIndex + 1; i < lines.length; i++) {
    const raw = lines[i];
    if (new RegExp(`^\\s*${fence}\\s*$`).test(raw)) {
      // закриття
      return { directive: { key, value: chunks.join('\n') }, nextIndex: i + 1 };
    }
    chunks.push(raw);
  }

  // якщо закриття не знайдено — вважаємо до кінця документа
  return { directive: { key, value: chunks.join('\n') }, nextIndex: i };
}


function parseDirectiveLine(line) {
  // приклади:
  // -- title="Role & Permission Management"
  // -- origin="123 456"
  // -- origin=123 456
  const t = line.replace(/^\s*--\s*/, '').trim();
  if (!t) return null;

  // дозволимо "key=value" або '"key=value"' як один токен
  const tokens = smartSplit(t);
  // об’єднаємо всі токени назад, бо опис може містити пробіли і не містити '=' в першому токені
  // Стратегія: шукаємо перший токен, що містить '=', і все ПІСЛЯ нього — частина значення (з урахуванням мерджу для координат).
  let key = null, value = '';

  // 1) якщо перший токен сам по собі не містить '=', тоді це може бути "key" + "=\<value\>"
  // але наш smartSplit вже зливає x = y → "x=y", тож орієнтуємось на перший '=' у токені
  let joined = tokens.join(' ');
  const eqIdx = joined.indexOf('=');
  if (eqIdx === -1) {
    // немає '=', трактуємо весь рядок як key з порожнім значенням
    key = joined.trim();
    value = '';
  } else {
    key = joined.slice(0, eqIdx).trim();
    value = joined.slice(eqIdx + 1).trim();

    // якщо value не в лапках і схоже на координати для origin/xy/wh — спробуємо змерджити "a b"
    // але ми вже працюємо зі змердженим рядком; тут просто приберемо навколишні лапки якщо є
  }

  // зняти лапки, якщо є
  value = unquote(value);

  // Спеціальний мердж для не лапкованих origin=123 456 (на цьому етапі вже об’єднано в один рядок).
  // Якщо значення виглядає як "number number" (через пробіл) — просто лишаємо як є ("123 456").
  // Нічого додаткового робити не треба.

  return { key, value };
}

function serializeDirective({ key, value }) {
  if (String(value).includes('\n')) {
    // багаторядкове — фенс з ```
    return `-- ${key}=\`\`\`\n${value}\n\`\`\``;
  }
  // для однорядкових — лапки (або можна зробити бектики, але лапки звичніші)
  return `-- ${key}=${quote(value)}`;
}


// ===================== Classifier =====================
function isCommentOrEmpty(line) {
  if (!line) return true;
  const t = line.trim();
  return !t || t.startsWith('#') || t.startsWith('//');
}
function classifyLine(line) {
  const t = line.trim();
  if (!t) return 'empty';
  if (/^--\s*/.test(t)) return 'directive';
  if (/^l:/i.test(t)) return 'relation';
  if (/^n:/i.test(t)) return 'note';
  if (/^p:/i.test(t)) return 'pen';
  if (/^a:/i.test(t)) return 'area';
  const tokens = smartSplit(t);
  if (tokens.length === 0) return 'empty';
  if (tokens.length === 1) return 'header';
  if (tokens[1].includes('=')) return 'header';
  return 'column';
}

// ===================== Document parser/serializer =====================
function parseDocument(text) {
  const tables = [];
  const lines = [];
  const notes = [];
  const pens = [];
  const areas = [];
  const globals = [];

  const rawLines = text.split(/\r?\n/);
  let current = null;

  for (let idx = 0; idx < rawLines.length; idx++) {
    const raw = rawLines[idx];
    if (isCommentOrEmpty(raw)) continue;

    const kind = classifyLine(raw);

    if (kind === 'directive') {
      const { directive, nextIndex } = parseDirectiveAt(rawLines, idx);
      if (directive) globals.push(directive);
      idx = nextIndex - 1; // -1 бо for++ зробить +1
      continue;
    }
    if (kind === 'relation') { lines.push(parseRefLine(raw)); continue; }
    if (kind === 'note') { notes.push(parseNoteLine(raw)); continue; }
    if (kind === 'pen') { pens.push(parsePenLine(raw)); continue; }

    if (kind === 'area') {
      const { area, nextIndex } = parseAreaBlock(rawLines, idx);
      areas.push(area);
      idx = nextIndex; // на порожньому рядку блок закінчується
      continue;
    }

    if (kind === 'header') {
      const h = parseTableHeader(raw);
      current = { name: h.name, attributes: h.attributes, columns: [] };
      tables.push(current);
      continue;
    }

    if (kind === 'column') {
      if (!current) throw new Error(`Column line before any table header: "${raw.trim()}"`);
      current.columns.push(parseColumn(raw));
      continue;
    }
  }

  const globalsMap = {};
  for (const d of globals) globalsMap[d.key] = d.value;

  return { tables, lines, notes, pens, areas, globals, globalsMap };
}

function stringifyDocument(doc, { indent = '  ', betweenTables = '\n\n' } = {}) {
  const parts = [];

  // 1) globals зверху в порядку появи
  if (doc.globals && doc.globals.length) {
    parts.push(doc.globals.map(serializeDirective).join('\n'));
  }

  // 2) таблиці
  const tblBlocks = (doc.tables || []).map(tbl => {
    const head = serializeTableHeader(tbl);
    const cols = (tbl.columns || []).map(c => indent + serializeColumn(c)).join('\n');
    return cols ? `${head}\n${cols}` : head;
  });
  if (tblBlocks.length) parts.push(tblBlocks.join(betweenTables));

  // 3) лінії / нотатки / pen / areas
  const relsTxt = (doc.lines || []).map(serializeRefLine).join('\n\n');
  const notesTxt = (doc.notes || []).map(serializeNote).join('\n\n');
  const pensTxt = (doc.pens || []).map(serializePen).join('\n\n');
  const areasTxt = (doc.areas || []).map(serializeArea).join('\n\n');

  if (relsTxt) parts.push(relsTxt);
  if (notesTxt) parts.push(notesTxt);
  if (pensTxt) parts.push(pensTxt);
  if (areasTxt) parts.push(areasTxt);

  return (parts.join('\n\n') + '\n').trimEnd() + '\n';
}

// // ===================== Demo =====================
// const sample = `

//   users xy="12312.2 12312.2" txy="0 0" border="solid" color="blue" note="some comment"
//     id int pk fk not_null increment index="unique" enum="" default_value="" generated_value="" check="" note="some comment"
//     name varchar(50) not_null index="unique" enum="" default_value="" generated_value="" check="" note="some comment"

//   l: users.id > roles.id on_delete="cascade" on_update="cascade" note="user has a role"

//   a: "xy=12312.2 12312.2" "wh=12312.2 12312.2" border="solid" color="blue" note="some comment"
// users
// roles

//   roles xy="12312.2 12312.2" txy="0 0" border="solid" color="blue" note="some comment"
//     id int pk fk not_null increment index="unique" enum="" default_value="" generated_value="" check="" note="some comment"
//     name varchar(50) not_null index="unique" enum="" default_value="" generated_value="" check="" note="some comment"

//     p: xy="12312.2 12312.2" txy="12312.2 12312.2" oxy="12312.2 12312.2" color="yellow" path="M-1525.68, -1517.04 Q-1499.20, -1462.49 ..."
// p: xy=100 200 color="red" path="M0,0 L10,10"

//     n: "Title with spaces" xy="123 456" wh="320 200" color="blue"
// n: "some note" "xy=10 20" wh="300 100"

// a: "xy=12312.2 12312.2" "wh=12312.2 12312.2" border="solid" color="blue" note="some comment"
// users
// roles

// n: "top-left sticker" id="n1" xy="100 200" wh="120 80"
// n: "another" xy="300 200" wh=160 60

// `;

// const parsed = parseDocument(sample);
// console.log(parsed);

// const roundtrip = stringifyDocument(parsed);
// console.log(roundtrip);


export { parseDocument, stringifyDocument };